import { SidebarConfig } from '@typings/app/sidebar.types';

export const ADMIN_SIDEBAR: SidebarConfig = {
  sections: [
    {
      items: [
        {
          labelKey: 'sidebar.dashboard',
          icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-home' },
          route: '/admin',
          permission: 'admin.users.view',
        },
      ],
    },
    {
      titleKey: 'sidebar.section.management',
      items: [
        {
          labelKey: 'sidebar.users',
          icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-users' },
          route: '/admin/users',
          permission: 'admin.users.view',
        },
        {
          labelKey: 'sidebar.companies',
          icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-building' },
          route: '/admin/companies',
          permission: 'admin.companies.view',
        },
        {
          labelKey: 'sidebar.reports',
          icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-chart-pie' },
          route: '/admin/reports',
          permission: 'admin.reports.view',
        },
      ],
    },
  ],
  bottomItems: [
    { labelKey: 'sidebar.settings', icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-settings' }, route: '/settings' },
  ],
};

export const EMPLOYER_SIDEBAR: SidebarConfig = {
  sections: [
    {
      titleKey: 'sidebar.section.recruitment',
      items: [
        {
          labelKey: 'sidebar.dashboard',
          icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-home' },
          route: '/recruitment/dashboard',
          visibleWhen: 'dashboardVisible',
        },
        {
          labelKey: 'sidebar.hire_requests',
          icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-briefcase' },
          route: '/recruitment/roles',
          activeMatchPaths: ['/recruitment/job-templates'],
          permission: 'recruitment.roles.view',
          visibleWhen: 'hasCompany',
        },
        // {
        //   labelKey: 'sidebar.candidates',
        //   icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-user' },
        //   route: '/recruitment/candidates',
        //   permission: 'recruitment.candidates.view',
        //   visibleWhen: 'companyVerified',
        // },
        // {
        //   labelKey: 'sidebar.interviews',
        //   icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-calendar' },
        //   route: '/recruitment/interviews',
        //   permission: 'recruitment.interviews.view',
        //   visibleWhen: 'companyVerified',
        // },
      ],
    },
  ],
  bottomItems: [
    { labelKey: 'sidebar.settings', icon: { fontSet: 'uicon-rr', fontIcon: 'fi-rr-settings' }, route: '/settings' },
  ],
};
